import { createSelector } from '@reduxjs/toolkit'
import { values, sortBy } from 'lodash-es'

export function getComments(state, props) {
  return state.data.comments
}

export const commentsListSelector = createSelector([getComments], function (comments) {
  return values(comments)
})

export const dateSortedCommentsListSelector = createSelector([commentsListSelector], function (commentsList) {
  return sortBy(commentsList, item => new Date(item.created_at))
})
